import React from 'react'
import styled from 'styled-components'
import IconButton from '@mui/material/IconButton'
import {Create} from '@mui/icons-material'

const Icon = styled(IconButton)`
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    padding: 5px;
    top: -15px;
    right: -15px;
    background: #eeeeee;
    position: absolute;

    :hover {
        background: #eeeeee;
    }
`

export default ({ onClick }) => <Icon onClick={onClick}><Create fontSize="small" /></Icon>
